<template>
    <div class="max-w-screen-xl px-4 py-4 mx-auto sm:px-6 sm:py-12 lg:px-8">
        <div
            class="flex flex-col items-start gap-4 md:flex-row md:items-center md:justify-between"
        >
            <div>
                <h1 class="text-2xl font-bold text-gray-900 sm:text-3xl">
                    Aktivasi
                </h1>

                <p class="mt-1.5 text-sm text-gray-500">
                    Data Aktivasi Aplikasi
                </p>
            </div>

            <div class="flex items-center gap-4">
                <button
                    v-if="$page.props.can.master_access"
                    class="inline-flex items-center px-4 py-2 text-sm font-semibold text-white bg-indigo-600 rounded-md shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    @click="isModalOpen = true"
                >
                    <svg
                        class="-ml-0.5 mr-2 h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd"
                        />
                    </svg>
                    Tambah
                </button>
            </div>
        </div>

        <div class="col-span-1 p-4 lg:col-span-2">
            <!-- Search Input -->
            <div class="relative mb-4 text-sm text-gray-800">
                <div
                    class="absolute top-0 bottom-0 left-0 flex items-center pl-2 text-gray-500 pointer-events-none"
                >
                    <MagnifyingGlassVue />
                </div>
                <input
                    v-model="search"
                    type="text"
                    autocomplete="off"
                    placeholder="Cari Nama..."
                    id="search"
                    class="block w-full py-2 pl-10 text-gray-900 border-0 rounded-lg ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
            </div>

            <!-- Table -->
            <div class="overflow-x-auto">
                <table class="min-w-full table-auto">
                    <thead class="bg-gray-50">
                        <tr>
                            <th
                                scope="col"
                                class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                            >
                                ID
                            </th>
                            <th
                                scope="col"
                                class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                            >
                                Program Studi
                            </th>
                            <th
                                scope="col"
                                class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                            >
                                Status
                            </th>
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                            >
                                Wa Service
                            </th>
                            <th
                                scope="col"
                                class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                            >
                                Tanggal Expire
                            </th>

                            <th
                                scope="col"
                                class="relative py-3.5 pl-3 pr-4 sm:pr-6"
                            >
                                <!-- Empty for Action Buttons -->
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                        <!-- Table Rows -->
                        <tr
                            v-for="(activ, index) in activate.data"
                            :key="activ.id"
                        >
                            <td
                                class="px-3 py-4 text-gray-500 whitespace-nowrap"
                            >
                                {{ index + 1 }}.
                            </td>
                            <td
                                class="px-3 py-4 text-gray-500 whitespace-nowrap"
                            >
                                {{ activ.studyProgram.name }}
                            </td>
                            <td
                                class="px-3 py-4 text-gray-500 whitespace-nowrap"
                            >
                                {{ activ.infosetactive }}
                            </td>
                            <td
                                class="px-3 py-4 text-gray-500 whitespace-nowrap"
                            >
                                {{ activ.infowaservice }}
                            </td>
                            <td
                                class="px-3 py-4 text-gray-500 whitespace-nowrap"
                            >
                                {{ activ.tanggal_expired }}
                            </td>

                            <td
                                class="flex items-center justify-center py-4 space-x-2"
                            >
                                <span
                                    class="inline-flex overflow-hidden bg-white border rounded-md shadow-sm"
                                >
                                    <button
                                        v-if="$page.props.can.master_access"
                                        @click="EditAktivasi(activ.id)"
                                        class="inline-block p-3 text-gray-700 border-e hover:bg-gray-50 focus:relative"
                                        title="Edit Data"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke-width="1.5"
                                            stroke="currentColor"
                                            class="size-4"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                            />
                                        </svg>
                                    </button>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Pagination -->
            <div class="flex justify-center mt-4">
                <Pagination
                    :data="activate"
                    :updatedPageNumber="updatedPageNumber"
                />
            </div>
        </div>
        <ModalAktivasi
            v-model:isOpen="isModalOpen"
            :title="form.id ? 'Edit Aktivasi' : 'Tambah Aktivasi'"
            :fakultas="props.faculty"
            :activ="selectedActivate"
        />
    </div>
</template>

<script setup>
import { useForm, usePage, router } from "@inertiajs/vue3";
import { ref, computed, watch } from "vue";

import Pagination from "@/Components/Pagination.vue";
import MagnifyingGlassVue from "@/Components/MagnifyingGlass.vue";

import ModalAktivasi from "@/Components/ModalAktivasi.vue";
const isModalOpen = ref(false);

const props = defineProps({
    activate: {
        type: Object,
        required: true,
    },
    faculty: {
        type: Object,
        required: true,
    },
});

/**
 * @param pagination
 */

let search = ref(usePage().props.search || ""),
    pageNumber = ref(1);

let studentUrl = computed(() => {
    let url = new URL(route("aktivasi.index"));
    url.searchParams.set("page", pageNumber.value); // Use 'set' to replace existing params
    if (search.value) {
        url.searchParams.set("search", search.value); // Use 'set' for search
    }

    return url;
});

const updatedPageNumber = (link) => {
    const params = new URLSearchParams(link.url.split("?")[1]);
    pageNumber.value = params.get("page");
};

watch(
    () => studentUrl.value,
    (updatedStudentUrl) => {
        router.visit(updatedStudentUrl.toString(), {
            preserveScroll: true,
            preserveState: true,
            replace: true,
        });
    }
);

watch(
    () => search.value,
    (value) => {
        if (value) {
            pageNumber.value = 1; // Reset to page 1 when search is updated
        }
    }
);
const form = useForm({
    id: null,
    nama: "",
    email: "",
});
const selectedActivate = ref(null);
const selectedFak = ref(null);

const EditAktivasi = async (id) => {
    try {
        const response = await fetch(`/aktivasi/${id}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        selectedActivate.value = data.activate;
        selectedFak.value = data.faculty;
        isModalOpen.value = true;
    } catch (error) {
        console.error("Error fetching data:", error.message);
    }
};
</script>
